(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdown(sectionEl, ids) {
    if (!sectionEl) return;

    var date     = sectionEl.dataset.launchDate     || '2026-07-15';
    var time     = sectionEl.dataset.launchTime     || '10:00';
    var timezone = sectionEl.dataset.launchTimezone || 'Asia/Kolkata';

    // Convert 12hr to 24hr
var ampm    = sectionEl.dataset.launchAmpm || 'AM';
var timeParts = time.split(':');
var hh = parseInt(timeParts[0], 10);
var mm = timeParts[1] || '00';
if (ampm === 'AM' && hh === 12) hh = 0;
if (ampm === 'PM' && hh !== 12) hh = hh + 12;
var hh24 = String(hh).padStart(2, '0');
var targetDateStr = date + 'T' + hh24 + ':' + mm + ':00';

    function getTargetMs() {
      try {
        var now = new Date();
        var nowInTZ = new Date(now.toLocaleString('en-US', { timeZone: timezone }));
        var targetLocal = new Date(targetDateStr);
        var diff = targetLocal - nowInTZ;
        return Date.now() + diff;
      } catch (e) {
        return new Date(targetDateStr + 'Z').getTime();
      }
    }

    var targetMs = getTargetMs();

    var daysEl    = document.getElementById(ids.days);
    var hoursEl   = document.getElementById(ids.hours);
    var minsEl    = document.getElementById(ids.minutes);
    var secsEl    = document.getElementById(ids.seconds);

    if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

    function getDom(el) {
      return el.querySelector('.fila-timer-card__num');
    }

    function setVal(el, val) {
      var numEl = getDom(el);
      if (!numEl) return;
      var newVal = pad(val);
      if (numEl.textContent !== newVal) {
        numEl.textContent = newVal;
        numEl.classList.remove('fila-flip');
        void numEl.offsetWidth;
        numEl.classList.add('fila-flip');
      }
    }

    function tick() {
      var now  = Date.now();
      var diff = targetMs - now;

      if (diff <= 0) {
        // Hero section — hide timer wrap
        var heroTimerWrap = sectionEl.querySelector('.fila-hero__timer-wrap');
        if (heroTimerWrap) heroTimerWrap.style.display = 'none';

        // Early access — hide countdown label + timer
        var earlyLabel = sectionEl.querySelector('.fila-early__countdown-label');
        var earlyTimer = sectionEl.querySelector('.fila-early__timer');
        if (earlyLabel) earlyLabel.style.display = 'none';
        if (earlyTimer) earlyTimer.style.display = 'none';

        clearInterval(intervalId);
        return;
      }

      var totalSecs = Math.floor(diff / 1000);
      var days      = Math.floor(totalSecs / 86400);
      var hours     = Math.floor((totalSecs % 86400) / 3600);
      var mins      = Math.floor((totalSecs % 3600) / 60);
      var secs      = totalSecs % 60;

      setVal(daysEl,  days);
      setVal(hoursEl, hours);
      setVal(minsEl,  mins);
      setVal(secsEl,  secs);
    }

    tick();
    var intervalId = setInterval(tick, 1000);
  }

  /* ---- Init Hero Timer ---- */
  var heroSection = document.getElementById('fila-hero');
  if (heroSection) {
    initCountdown(heroSection, {
      days:    'hero-days',
      hours:   'hero-hours',
      minutes: 'hero-minutes',
      seconds: 'hero-seconds'
    });
  }

  /* ---- Init Early Access Timer ---- */
  var earlySection = document.getElementById('fila-early-access');
  if (earlySection) {
    initCountdown(earlySection, {
      days:    'early-days',
      hours:   'early-hours',
      minutes: 'early-minutes',
      seconds: 'early-seconds'
    });
  }

  /* ----------------------------------------------------------
     FORM SUBMISSION
  ---------------------------------------------------------- */
  window.filaSubmitForm = function () {
    var section = document.getElementById('fila-early-access');
    if (!section) return;

    var emailEl    = document.getElementById('fila_email');
    var phoneEl    = document.getElementById('fila_phone');
    var btn        = document.getElementById('fila-submit-btn');
    var btnLabel   = document.getElementById('fila-btn-label');
    var btnLoading = document.getElementById('fila-btn-loading');

    clearErrors();

    var valid = true;

    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailEl) {
      if (!emailEl.value.trim()) {
        showError('err-email', 'Email is required');
        valid = false;
      } else if (!emailPattern.test(emailEl.value.trim())) {
        showError('err-email', 'Enter a valid email address');
        valid = false;
      }
    }

    var phonePattern = /^[\d\s\+\-\(\)]{7,15}$/;
    if (phoneEl) {
      if (!phoneEl.value.trim()) {
        showError('err-phone', 'Phone is required');
        valid = false;
      } else if (!phonePattern.test(phoneEl.value.trim())) {
        showError('err-phone', 'Enter a valid phone number');
        valid = false;
      }
    }

    if (!valid) return;

    btn.disabled = true;
    btnLabel.style.display = 'none';
    btnLoading.style.display = 'flex';

    var payload = {
      timestamp: new Date().toISOString(),
      email:     emailEl ? emailEl.value.trim() : '',
      phone:     phoneEl ? phoneEl.value.trim() : ''
    };

    var sheetsUrl = section.dataset.sheetsUrl || '';

    if (sheetsUrl) {
      fetch(sheetsUrl, {
        method: 'POST',
        mode:   'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function () {
        showSuccess();
      })
      .catch(function (err) {
        console.warn('FILA: Sheets submission error', err);
        showSuccess();
      });
    } else {
      console.log('FILA: Form data (no webhook URL set)', payload);
      setTimeout(showSuccess, 800);
    }
  };

  function showSuccess() {
    var formInner   = document.getElementById('fila-form-inner');
    var formSuccess = document.getElementById('fila-form-success');
    var btn         = document.getElementById('fila-submit-btn');

    if (formInner)   formInner.style.display  = 'none';
    if (formSuccess) formSuccess.style.display = 'flex';
    if (btn) btn.disabled = false;
  }

  function showError(id, msg) {
    var el = document.getElementById(id);
    if (el) el.textContent = msg;
  }

  function clearErrors() {
    ['err-name', 'err-email', 'err-phone'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = '';
    });
  }

})();